import { useEffect, useState } from 'react';
import { onlineStatusService } from '../services/offline';
import { syncQueueService } from '../services/syncQueue';
import './OfflineStatus.css';

export function OfflineStatus() {
  const [isOnline, setIsOnline] = useState(onlineStatusService.getStatus());
  const [isSyncing, setIsSyncing] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const unsubscribeOnline = onlineStatusService.subscribe((online) => {
      setIsOnline(online);
    });

    const unsubscribeSync = syncQueueService.subscribe((syncing) => {
      setIsSyncing(syncing);
    });

    // Обновляем счетчик ожидающих запросов
    const updatePendingCount = async () => {
      const count = await syncQueueService.getPendingCount();
      setPendingCount(count);
    };

    updatePendingCount();
    const interval = setInterval(updatePendingCount, 5000);

    return () => {
      unsubscribeOnline();
      unsubscribeSync();
      clearInterval(interval);
    };
  }, []);

  if (isOnline && pendingCount === 0) {
    return null; // Не показываем, если все в порядке
  }

  return (
    <div className={`offline-status ${isOnline ? 'online' : 'offline'}`}>
      {!isOnline ? (
        <div className="offline-message">
          <span className="offline-icon">📴</span>
          <span>Офлайн режим. Данные сохраняются локально.</span>
        </div>
      ) : isSyncing ? (
        <div className="syncing-message">
          <span className="syncing-icon">🔄</span>
          <span>Синхронизация данных...</span>
        </div>
      ) : pendingCount > 0 ? (
        <div className="pending-message">
          <span className="pending-icon">⏳</span>
          <span>Ожидает синхронизации: {pendingCount} запросов</span>
        </div>
      ) : null}
    </div>
  );
}

